import 'shop/assets/js/component/form/newsletter';
import 'shop/assets/js/component/shared/loader-button';

(function () {
    const nextPageButton = document.getElementById('next-page');
    const prevPageButton = document.getElementById('prev-page');
    const productOrderContainer = document.getElementById('products-order');

    if (nextPageButton) {
        nextPageButton.addEventListener('click', () => {
            window.location.assign(nextPageButton.dataset.url);
        });
    }

    if (prevPageButton) {
        prevPageButton.addEventListener('click', () => {
            window.location.assign(prevPageButton.dataset.url);
        });
    }

    if (productOrderContainer) {
        productOrderContainer.querySelectorAll('.dropdown-item').forEach((item) => {
            item.addEventListener('click', () => {
                window.location.assign(item.dataset.url);
            });
        });
    }

    document.addEventListener('alpine:init', () => {
        window.Alpine.data('FilterableProductList', () => ({
            appliedFilters: {},
            totalAppliedFilters: 0,
            init() {
                const filters = this.$el.dataset.filters;

                if (!filters) {
                    return;
                }

                const parsedFilters = JSON.parse(filters);

                for (let key in parsedFilters) {
                    if (Object.prototype.hasOwnProperty.call(parsedFilters, key)) {
                        this.appliedFilters[key] = this.getFilterCount(key, parsedFilters[key]);
                    }
                }

                this.setTotalAppliedFilters();
            },
            isMobileDevice() {
                return window.matchMedia('(max-width: 992px)').matches;
            },
            getFilterCount(filterType, filterValues) {
                switch (filterType) {
                    case 'facets':
                        return this.getAttributeFilterCount(filterValues);
                    case 'price':
                        return this.getPriceFilterCount(filterValues);
                    default:
                        return {};
                }
            },
            getAttributeFilterCount(filterValues) {
                let filters = {};

                for (let [attributeFilter, values] of Object.entries(filterValues)) {
                    filters[attributeFilter] = values.length;
                }

                return filters;
            },
            getPriceFilterCount(filterValues) {
                for (let value of Object.values(filterValues)) {
                    if (value) {
                        return 1;
                    }
                }

                return 0;
            },
            setTotalAppliedFilters() {
                let count = 0;

                for (let value of Object.values(this.appliedFilters)) {
                    if (typeof value === 'object' && value !== null) {
                        Object.entries(value).forEach(() => (count += 1));
                    } else if (value) {
                        count += 1;
                    }
                }

                this.totalAppliedFilters = count;
            },
        }));
    });
})();
